import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assigneeData: [],
};

const assigneeDataSlice = createSlice({
  name: "assigneeData",
  initialState,
  reducers: {
    setAssigneeData: (state, action) => {
      state.assigneeData = action.payload;
    },
  },
});

export const { setAssigneeData } = assigneeDataSlice.actions;
export const selectAssigneeData = (state) => state.assigneeData.assigneeData;

export default assigneeDataSlice.reducer;
